import React, {
    Component,
} from 'react';

import PropTypes from 'prop-types';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';
import FaClose from 'react-icons/lib/fa/close';
import {
    withRouter,
} from 'react-router';

import {
    localize,
} from 'wanderu-i18n';
import {
    goBackOrFallback,
} from 'wanderu-utils';

import Lightbox from '../Lightbox/Lightbox';
import Modal from '../Modal/Modal';

import styles from './NavigableModal.scss';

class NavigableModal extends Component {
    static propTypes = {
        className: PropTypes.string,
        hash: PropTypes.string.isRequired,
        onClose: PropTypes.func.isRequired,
    }

    static defaultProps = {
        className: '',
    }

    componentDidMount() {
        const {
            hash,
            history,
            location,
            onClose,
        } = this.props;

        // test against the history object, not the location prop provided by <Route> as
        // recommended by the react-router docs.  this avoids a race where this component
        // unmounts before <Route> updates (which would cause history.pop() to be called twice)
        if (history.location.hash !== hash) {
            history.push(`${location.pathname}${location.search}${hash}`);
        }

        this._unlisten = history.listen((location, action) => {
            if (action === 'POP') {
                this._unlisten();
                onClose();
            }
        });
    }

    componentWillUnmount() {
        const {
            hash,
            history,
            location,
        } = this.props;
        const {
            pathname,
            search,
        } = location;

        // unmounting without a hash change implies that this modal was programmatically
        // dismissed, so pop an entry from the history stack here to sync up
        //
        // test against the history object, not the location prop provided by <Route> as
        // recommended by the react-router docs.  this avoids a race where this component
        // unmounts before <Route> updates (which would cause history.pop() to be called twice)
        if (history.location.hash === hash) {
            this._unlisten();
            goBackOrFallback(history, `${pathname}${search}`);
        }
    }

    onClose = () => {
        const {
            history,
            location,
        } = this.props;
        const {
            pathname,
            search,
        } = location;

        // TODO: more testing when page loads with anchor tag
        goBackOrFallback(history, `${pathname}${search}`);
    }

    render() {
        const {
            children,
            className,
            t,
            title,
        } = this.props;

        return (
            <Modal className={className}>
                <Lightbox
                    className={styles.navigableModal}
                    innerClassName={styles.lightboxContents}
                    onHide={this.onClose}
                    showCloseButton={false}
                >
                    <div
                        aria-labelledby="navigable-modal-title"
                        className={styles.topBar}
                    >
                        <button
                            aria-label={t('close')}
                            className={styles.backButton}
                            onClick={this.onClose}
                        >
                            <FaChevronLeft className={`${styles.backButtonIcon} ${styles.mobile}`} />

                            <FaClose className={`${styles.backButtonIcon} ${styles.desktop}`} />
                        </button>

                        <span
                            className={styles.title}
                            id="navigable-modal-title"
                        >
                            {title}
                        </span>
                    </div>

                    {children}
                </Lightbox>
            </Modal>
        );
    }
}

export {
    NavigableModal,
};

export default withRouter(localize(NavigableModal, 'baseApp'));
